<script setup>
import { Link, Head, router } from '@inertiajs/vue3';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import InputField from '@js/components/fields/InputField.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { toastError } from '@js/utils/toast';
import { Form } from 'vee-validate';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { route } = useRoute();

const isSubmitting = ref(false);

const form = reactive({
    email: '',
    password: '',
});

const validationSchema = object({
    email: string()
        .required("L'email est requis.")
        .email("Le format de l'email est invalide."),
    password: string().required('Le mot de passe est requis.'),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(route('front.postLogin'), {
            email: form.email,
            password: form.password,
        })
        .then((response) => {
            if (response.data.status === 'success') {
                router.visit(route('front.index'));
            } else if (response.data.status === 'failed') {
                toastError('Les identifiants sont incorrects.');
            } else {
                toastError('Une erreur est survenue.');
            }
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);
        });
}
</script>

<template>
    <Head>
        <title>Connexion - Datakepler</title>
    </Head>

    <div
        class="flex h-full flex-col items-center justify-center bg-gray-100 p-4"
    >
        <img
            src="/images/logo/logo.svg"
            alt="Datakepler"
            class="mb-6 w-48 md:w-60"
        />

        <Form
            v-slot="{ errors }"
            :validation-schema="validationSchema"
            class="w-full max-w-md rounded border border-gray-200 bg-white p-6"
            @submit="submit"
        >
            <PageTitle> Connexion </PageTitle>

            <InputField
                v-model="form.email"
                label="Email"
                field-name="email"
                field-id="email"
                type="email"
                required
            />

            <InputField
                v-model="form.password"
                label="Mot de passe"
                field-name="password"
                field-id="password"
                type="password"
                required
            />

            <Link
                :href="route('front.forgotPassword')"
                class="text-sm hover:underline"
            >
                Mot de passe oublié
            </Link>

            <div class="mt-6">
                <ActionButton
                    submit
                    :disabled="Object.keys(errors).length > 0 || isSubmitting"
                    class="w-full"
                    size="large"
                    :loading="isSubmitting"
                >
                    Connexion
                </ActionButton>
            </div>
        </Form>
    </div>
</template>
